// extracted by mini-css-extract-plugin
export default {"logo":"logo--PQdhK","logo__background-strip":"logo__background-strip--DSeq0","logo__icon":"logo__icon--U3uuG"};